import { TIER_LABELS, type SelectedFeature } from './layers';

/** Ficha mínima de la entidad clickeada — mismo componente en Ficha y Visor, nunca JSON crudo. */
export function EntityPopupCard({
  feature,
  onClose,
  className = 'ft-popup-card',
}: {
  feature: SelectedFeature;
  onClose: () => void;
  className?: string;
}): JSX.Element {
  return (
    <div className={className}>
      <button className="ft-popup-close" onClick={onClose} aria-label="Cerrar">
        ×
      </button>
      <p className="ft-popup-category">{feature.category}</p>
      <p className="ft-popup-name">{feature.name ?? <i>Sin nombre</i>}</p>
      {feature.osmSubtype && <p className="ft-popup-row">Subtipo: {feature.osmSubtype}</p>}
      {feature.hasNetworkAssociation !== undefined && (
        <p className="ft-popup-row">
          {feature.hasNetworkAssociation ? 'Asociado a la red vial' : 'Sin asociación a la red'}
        </p>
      )}
      {feature.tier && <p className="ft-popup-row">{TIER_LABELS[feature.tier]}</p>}
    </div>
  );
}
